import React,{useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dialog } from "primereact/dialog";

import { Button, CalendarField, DropDownField, TextAreaField, TextInputField } from "../../../helpers";

import { getChequeByChequeBookId } from "../../../services/api/cheques";
import { fetchChequeBooks } from "../../../services/redux/reducers/commonThunk";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { Oval } from "react-loader-spinner";


const ChequeModal = (props) =>{
    const { setIsChequeModalVisible, handlePaymentDoneClick } = props

    const [isChequesLoading, setIsChequesLoading] = useState(false)
    const [chequeBooks, setChequeBooks] = useState([])
    const [selectedChequeBookId, setSelectedChequeBookId] = useState(null)
    const [availableChequeNos, setAvailableChequeNos] = useState([])
    const [chequeDetails, setChequeDetails] = useState({})

    const dispatch = useDispatch()
    const chequeBooksData = useSelector(state => state.common.chequeBooks)

    useEffect(() => {
        dispatch(fetchChequeBooks())
    }, [])

    useEffect(() => {
        getAllChequeBooks()
    }, [chequeBooksData])

    useEffect(() => {
        getAvailableChequeNos()
    }, [selectedChequeBookId])

    const getAllChequeBooks = () => {
        if(chequeBooksData.length > 0){
            const updatedData = chequeBooksData.map(eachChequeBook => {
                const relatedBank = eachChequeBook.companyBankAccounts
                let label = `${relatedBank?.bankName} | A/C No. ${relatedBank?.accNo} | Cheque Series- From ${eachChequeBook.chequeSeriesFrom} to ${eachChequeBook.chequeSeriesTo}`
                return {...eachChequeBook, label: label}
            })
            setChequeBooks(updatedData)
        }
    }

    const getAvailableChequeNos = async () => {
        if (selectedChequeBookId){
            setIsChequesLoading(true)
            const response = await getChequeByChequeBookId(selectedChequeBookId)

            if (response?.failure){
                dispatch(raiseToast({severity: 'error', summary: 'Cheque Nos not fetched', detail: response.data.error, life: 3000}))
            } else {
                const relatedChequeBook = chequeBooks?.find(eachChequeBook => eachChequeBook?.chequeBookId === selectedChequeBookId)
                const allAvailableCheques = []
                for (let i = parseInt(relatedChequeBook?.chequeSeriesFrom); i < relatedChequeBook?.chequeSeriesTo; i++) {
                    const relatedChequeNo = response?.data?.find(eachCheque => parseInt(eachCheque?.chequeNo) === i)
                    if (!relatedChequeNo){
                        allAvailableCheques.push(i)
                    }
                }
                setAvailableChequeNos(allAvailableCheques)
            }
            setIsChequesLoading(false)
        }
    }
   
    const handleAssignClick = () => {
        if(!availableChequeNos.includes(parseInt(chequeDetails.chequeNo))){
            dispatch(raiseToast({severity: 'error', detail: "Please select correct cheque number"}))
            return 
        }
        if(!chequeDetails.chequeDate){
            dispatch(raiseToast({severity: 'error', detail: "Please select cheque date"}))
            return 
        }
        handlePaymentDoneClick({...chequeDetails, chequeBookId : selectedChequeBookId})
        setSelectedChequeBookId(null)
        setChequeDetails({})
        setAvailableChequeNos([])
    }

    const handleChange = (e) => {
        setChequeDetails(prevState => ({...prevState, [e.target.name]: e.target.value}))
    }

    const handleCancelClick = () => {
        setIsChequeModalVisible(false)
        setChequeDetails({})
        setSelectedChequeBookId(null)
        setAvailableChequeNos([])
    }

    const assignChequeFooterContent = () => {
        return(
            <div className="mt-2">
                <Button label="CANCEL" severity="danger" outlined onClick={() => handleCancelClick()} />
                <Button label="ASSIGN" outlined onClick={() => handleAssignClick()}/>
            </div>
        )
    }

    const handleSelectChequeNo = (chequeNo) => {
        setChequeDetails(prevState => ({...prevState, "chequeNo": chequeNo}))
    }

    const handleSelectChequeBook = (e) => {
        setSelectedChequeBookId(e.target.value)
        setChequeDetails(prevState => ({...prevState, "chequeNo": null}))
    }

    const chequeNosText = availableChequeNos.join(", ")

    return(
        <>
            <Dialog className="seller-search-modal" header={props.header} visible={props.visible} style={{ width: '60vw',minHeight:"60%" }} onHide={props.onHide} footer={assignChequeFooterContent}>
                <div style={{overflow:"hidden"}}>
                    <div className="search-box">
                        <div className="">
                            <div className="grid">
                                <div className="flex flex-column col-12 mb-2 lg:col-12 lg:mb-0">
                                    <DropDownField name="" labelText="" options={chequeBooks} optionValue="chequeBookId" optionLabel="label" value={selectedChequeBookId} placeholder='Select Cheque Book' onChange={(e) => handleSelectChequeBook(e)}/>
                                </div>
                            </div>
                        </div>
                        <div className="">
                            {(selectedChequeBookId  && availableChequeNos?.length) ? <h5>Select a Cheque No.</h5> : null}
                            <div className="flex flex-row flex-wrap">
                                {/* <div className="flex flex-column">
                                    <div className="flex flex-column col-12 lg:col-12 pl-0 pb-0">
                                        <TextInputField name="chequeNo" labelText="Cheque No." value={chequeDetails?.chequeNo} onChange={(e) => handleChange(e)}/>
                                    </div>
                                    <div className="flex flex-column col-12 lg:col-12 pl-0">
                                        <CalendarField name="chequeDate" labelText="Cheque Date" value={chequeDetails?.chequeDate} onChange={(e) => handleChange(e)}/>
                                    </div>
                                </div>
                                <div className="flex flex-column col-12 mb-2 lg:col-9 lg:mb-0 pr-0">
                                    <TextAreaField name="" labelText="Available Cheque NOs." rows={5} value={chequeNosText}/>
                                </div> */}
                                {
                                    isChequesLoading ? 
                                    <div className="flex flex-row justify-content-center">
                                        <Oval
                                            height={45}
                                            width={45}
                                            color="#00baac"
                                            visible={true}
                                            ariaLabel='oval-loading'
                                            secondaryColor="#a4a7a6"
                                        />
                                    </div> :
                                    (
                                        availableChequeNos?.length && selectedChequeBookId ?
                                        (
                                            availableChequeNos?.map(eachChequeNo => {
                                                let isChequeNoSelected = (eachChequeNo === chequeDetails?.chequeNo)
                                                return (
                                                    <div  className={`mr-2 mb-2 custom-button ${isChequeNoSelected ? 'active' : ''}`} onClick={() => handleSelectChequeNo(eachChequeNo)}>
                                                        {eachChequeNo}
                                                    </div>
                                                )
                                            })
                                        ) : 
                                        (
                                            selectedChequeBookId ? 
                                            <div className="flex flex-row text-center">
                                                <p className="text-center">Cheque No.s are not Available for the Selected Cheque Book.</p>
                                            </div> :
                                            null
                                        )
                                    )
                                }
                            </div>
                            <div className="flex flex-row">
                                <div className="flex flex-column col-12 lg:col-4 pl-0">
                                    <CalendarField name="chequeDate" labelText="Cheque Date" value={chequeDetails?.chequeDate} onChange={(e) => handleChange(e)}/>
                                </div>
                                <div className="flex flex-column col-12 lg:col-2 pl-0 pb-0 ml-2">
                                    <TextInputField name="chequeNo" labelText="Cheque No." value={chequeDetails?.chequeNo} disabled/>
                                </div>
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-12 lg:mb-0 px-0">
                                <TextAreaField name="remarks" labelText="Remarks" rows={6} value={chequeDetails?.remarks} onChange={(e) => handleChange(e)}/>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    )
}

export default ChequeModal;